import React from 'react';
import { connect } from 'react-redux';
import { IFormDataTemplate } from '../../../../Utils/types';
import { localization } from '../../../../Utils/Localization/localization';
import { Button, Input } from 'antd';
import { languageSelector } from '../../../../Redux/Reducers/settingsReducer';
import {
  auth,
  setAuthData,
  authDataSelector
} from '../../../../Redux/Reducers/authReducer';
import classes from './LoginPage.module.scss';

interface StateProps {
  language: string,
  authData: IFormDataTemplate
}
interface DispatchProps {
  auth: () => void,
  setAuthData: (name: string, value: string) => void
}
interface Props extends StateProps, DispatchProps { }

function LoginPage(props: Props) {
  function formDataHandler(e: React.ChangeEvent<HTMLInputElement>) {
    const { name, value } = e.target;
    props.setAuthData(name, value);
  }

  function authHandler() {
    props.auth();
  }

  return (
    <form className={classes.LoginPage}>
      <h1>{localization('auth', props.language)}</h1>
      <div>
        <Input type="text" name='email' id='email' placeholder={localization('email', props.language)} value={props.authData.email.value} onChange={formDataHandler} />
        {
          !props.authData.email.valid
          && <label htmlFor='email'>{localization('invalidInputField', props.language)}</label>}
      </div>
      <div>
        <Input type="password" name='password' id='password' placeholder={localization('password', props.language)}  value={props.authData.password.value} onChange={formDataHandler} />
        {
          !props.authData.password.valid
          && <label htmlFor='password'>{localization('invalidInputField', props.language)}</label>
        }
      </div>
      <Button disabled={!props.authData.email.valid || !props.authData.password.valid} onClick={authHandler}>{localization('auth', props.language)}</Button>
    </form>
  );
}

function mapStateToProps(state: any) {
  return {
    language: languageSelector(state),
    authData: authDataSelector(state)
  }
}
const mapDispatchToProps = {
  auth,
  setAuthData
}

const ConnectedLoginPage = connect(mapStateToProps, mapDispatchToProps)(LoginPage);

export { ConnectedLoginPage as LoginPage };